import { ComparisonOperator } from "../../api/models";

export let ComparisonOperatorEnumDisplay: { [index: number]: string } = {};
ComparisonOperatorEnumDisplay[ComparisonOperator.EqualTo] = "enums.ComparisonOperator.EqualTo";
ComparisonOperatorEnumDisplay[ComparisonOperator.NotEqualTo] = "enums.ComparisonOperator.NotEqualTo";
ComparisonOperatorEnumDisplay[ComparisonOperator.GreaterThan] = "enums.ComparisonOperator.GreaterThan";
ComparisonOperatorEnumDisplay[ComparisonOperator.LessThan] = "enums.ComparisonOperator.LessThan";
ComparisonOperatorEnumDisplay[ComparisonOperator.GreaterThanOrEqual] = "enums.ComparisonOperator.GreaterThanOrEqual";
ComparisonOperatorEnumDisplay[ComparisonOperator.LessThanOrEqual] = "enums.ComparisonOperator.lessThanOrEqual";
ComparisonOperatorEnumDisplay[ComparisonOperator.Contains] = "enums.ComparisonOperator.Contains";
ComparisonOperatorEnumDisplay[ComparisonOperator.NotContains] = "enums.ComparisonOperator.NotContains";
ComparisonOperatorEnumDisplay[ComparisonOperator.StartsWith] = "enums.ComparisonOperator.StartsWith";
ComparisonOperatorEnumDisplay[ComparisonOperator.EndsWith] = "enums.ComparisonOperator.EndsWith";


